import * as Yup from 'yup';
import { requiredField } from './utils/messages';

export const addHoursValidationSchema = Yup.object().shape({
  quantidade: Yup.string().required(requiredField),
  valor: Yup.string().required(requiredField),
  dataExpiracao: Yup.string().required(requiredField),
});

export const reportsGenerationValidationSchema = Yup.object().shape({
  periodoInicial: Yup.string().required(requiredField),
  periodoFinal: Yup.string().required(requiredField),
});
// reportsGenerationValidationSchema
